import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  colorPaletteWrapper: {
    width: '285px',
    height: '204px',
    marginLeft: '30px'
  },
  colorPalette: {
    position: 'relative',
    width: '285px',
    height: '204px',
    borderRadius: '3px',
    backgroundColor: '#E5E5E5'
  },
  closeBtn: {
    position: 'absolute',
    top: '-12px',
    right: '-12px',
    fontSize: '15px',
    padding: '10px'
  },
  closeIcon: {
    fontSize: '15px',
    color: '#000'
  },
  colorPickerWrapper: {
    zIndex: 999,
    top: '-30px',
    left: '70px',
    backgroundColor: '#fff',
    position: 'absolute'
  },
  errorOpenedPicker: {
    position: 'relative',
    zIndex: 1,
    margin: '-10px 0 35px'
  }
});

export default useStyles;
